export * from "./pay-rate"
export * from "./gcash-acc"
export * from "./gcash-add-transaction"
export * from "./co-list"
export * from "./co-register"
export * from "./co-history"
export * from "./giftcode-claim"
export * from "./rw-info"
export * from "./rw-friends"
export * from "./rw-history"
export * from "./rw-history-info"

export const ACTION_GET_PAYMENT_RATE =  "GET_PAYMENT_RATE";
export const ACTION_GET_PAYMENT_RATE_SUCCESS =  "GET_PAYMENT_RATE_SUCCESS";
export const ACTION_GET_PAYMENT_RATE_ERROR =  "GET_PAYMENT_RATE_ERROR";

export const ACTION_GET_GCASH_ACCOUNT_LISTS = "GET_GCASH_ACCOUNT_LISTS";
export const ACTION_GET_GCASH_ACCOUNT_LISTS_SUCCESS = "GET_GCASH_ACCOUNT_LISTS_SUCCESS";
export const ACTION_GET_GCASH_ACCOUNT_LISTS_ERROR = "GET_GCASH_ACCOUNT_LISTS_ERROR";

export const ACTION_GCASH_ADD_TRANSACTION = "GCASH_ADD_TRANSACTION";
export const ACTION_GCASH_ADD_TRANSACTION_SUCCESS = "GCASH_ADD_TRANSACTION_SUCCESS";
export const ACTION_GCASH_ADD_TRANSACTION_ERROR = "GCASH_ADD_TRANSACTION_ERROR";

export const ACTION_GET_CASHOUT_LIST = "GET_CASHOUT_LIST";
export const ACTION_GET_CASHOUT_LIST_SUCCESS = "GET_CASHOUT_LIST_SUCCESS";
export const ACTION_GET_CASHOUT_LIST_ERROR = "GET_CASHOUT_LIST_ERROR";

export const ACTION_CASHOUT_REGISTER = "CASHOUT_REGISTER";
export const ACTION_CASHOUT_REGISTER_SUCCESS = "CASHOUT_REGISTER_SUCCESS";
export const ACTION_CASHOUT_REGISTER_ERROR = "CASHOUT_REGISTER_ERROR";

export const ACTION_CASHOUT_HISTORY = "CASHOUT_HISTORY";
export const ACTION_CASHOUT_HISTORY_SUCCESS = "CASHOUT_HISTORY_SUCCESS";
export const ACTION_CASHOUT_HISTORY_ERROR = "CASHOUT_HISTORY_ERROR";


export const ACTION_GIFTCODE_CLAIM = "GIFTCODE_CLAIM";
export const ACTION_GIFTCODE_CLAIM_SUCCESS = "GIFTCODE_CLAIM_SUCCESS";
export const ACTION_GIFTCODE_CLAIM_ERROR = "GIFTCODE_CLAIM_ERROR";

export const ACTION_REWARD_INFO = "REWARD_INFO";
export const ACTION_REWARD_INFO_SUCCESS = "REWARD_INFO_SUCCESS";
export const ACTION_REWARD_INFO_ERROR = "REWARD_INFO_ERROR";

export const ACTION_REWARD_FRIENDS = "REWARD_FRIENDS";
export const ACTION_REWARD_FRIENDS_SUCCESS = "REWARD_FRIENDS_SUCCESS";
export const ACTION_REWARD_FRIENDS_ERROR = "REWARD_FRIENDS_ERROR";

export const ACTION_REWARD_HISTORY = "REWARD_HISTORY";
export const ACTION_REWARD_HISTORY_SUCCESS = "REWARD_HISTORY_SUCCESS";
export const ACTION_REWARD_HISTORY_ERROR = "REWARD_HISTORY_ERROR";

export const ACTION_REWARD_HISTORY_INFO = "REWARD_HISTORY_INFO";
export const ACTION_REWARD_HISTORY_INFO_SUCCESS = "REWARD_HISTORY_INFO_SUCCESS";
export const ACTION_REWARD_HISTORY_INFO_ERROR = "REWARD_HISTORY_INFO_ERROR";
